export default __webpack_public_path__ + "static/media/640_dummy2016-yoga02-mobile-de.78630afe.png";